import lodashIncludes from 'lodash/includes';

export const getParams = id => {
  if (lodashIncludes(id, '@')) {
    const [videoId, section] = id.split('@');
    return [videoId, section];
  }
  return [id, null];
};
